module.exports = __webpack_public_path__ + "a1cf5475e0e093503bc13fbcd7757476.png";